var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgViewIcon = function SvgViewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.58 8.89c-1.98-2.181-5.25-4.498-8.571-4.438-3.322.06-6.592 2.257-8.572 4.439a1.665 1.665 0 0 0 0 2.25c1.32 1.424 4.627 4.409 8.571 4.409s7.244-3 8.571-4.447a1.664 1.664 0 0 0 0-2.212zM6.56 10a3.45 3.45 0 1 1 6.898 0 3.45 3.45 0 0 1-6.899 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M10.008 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"
  })));
};
export { SvgViewIcon as ReactComponent };